import React from 'react';
import Button from '../ui/Button';
import { CheckIcon, BoxIcon, FileTextIcon, BarChartIcon } from 'lucide-react';
const OfferSection = () => {
  const packageOptions = [{
    title: 'Starter Pack',
    price: '€59',
    originalPrice: '€89',
    description: 'Perfect for first-time users',
    image: 'https://images.unsplash.com/photo-1612837017391-4b6b7b0e2b0b?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80',
    features: ['30-Night Supply of Performance Patches'],
    buttonText: 'Get Starter Pack',
    highlight: false
  }, {
    title: 'Performance Pack',
    price: '€99',
    originalPrice: '€149',
    description: 'Our most popular option',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80',
    features: ['60-Night Supply of Performance Patches'],
    buttonText: 'Get Performance Pack',
    highlight: true
  }, {
    title: 'Executive Pack',
    price: '€139',
    originalPrice: '€209',
    description: 'Best value for committed professionals',
    image: 'https://images.unsplash.com/photo-1576602976047-174e57a47881?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80',
    features: ['90-Night Supply of Performance Patches', 'Sleep Optimization Guide', 'Performance Tracking System'],
    buttonText: 'Get Executive Pack',
    highlight: false
  }];
  return <section className="bg-gradient-to-r from-indigo-900 to-purple-900 text-white py-16 md:py-24" data-id="element-183">
      <div className="container mx-auto px-4" data-id="element-184">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6" data-id="element-185">
          Choose Your Performance Package
        </h2>
        <p className="text-lg md:text-xl text-center max-w-3xl mx-auto mb-12" data-id="element-186">
          Select the package that best fits your performance goals. All packages
          include free shipping across the EU.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-187">
          {packageOptions.map((pkg, index) => <div key={index} className={`bg-white text-gray-800 rounded-xl shadow-xl overflow-hidden flex flex-col ${pkg.highlight ? 'border-4 border-indigo-500 transform md:scale-105' : ''}`} data-id="element-188">
              <div className="w-full h-48 overflow-hidden" data-id="element-189">
                <img src={pkg.image} alt={`NightPhase ${pkg.title} package`} className="w-full h-full object-cover" data-id="element-190" />
              </div>
              <div className={`p-6 ${pkg.highlight ? 'bg-indigo-50' : ''}`} data-id="element-191">
                <h3 className="text-2xl font-bold mb-2" data-id="element-192">{pkg.title}</h3>
                <p className="text-gray-600 mb-4" data-id="element-193">{pkg.description}</p>
                <div className="mb-4" data-id="element-194">
                  <div className="flex items-center" data-id="element-195">
                    <p className="text-gray-500 line-through text-lg mr-3" data-id="element-196">
                      {pkg.originalPrice}
                    </p>
                    <p className="text-3xl font-bold text-indigo-800" data-id="element-197">
                      {pkg.price}
                    </p>
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-198">
                    One-time purchase, no subscription
                  </p>
                </div>
              </div>
              <div className="p-6 flex-grow" data-id="element-199">
                <div className="mb-6" data-id="element-200">
                  <h4 className="font-semibold mb-3" data-id="element-201">Package includes:</h4>
                  <ul className="space-y-3" data-id="element-202">
                    {pkg.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-203">
                        <CheckIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-204" />
                        <span data-id="element-205">{feature}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
              <div className="p-6 pt-0" data-id="element-206">
                <a href="https://get.myhealthbeam.com/mptestcheck" className="block w-full" data-id="element-207">
                  <Button className={`w-full py-4 ${pkg.highlight ? 'bg-indigo-600 hover:bg-indigo-700 text-white' : ''}`} data-id="element-208">
                    {pkg.buttonText}
                  </Button>
                </a>
                <div className="flex items-center justify-center mt-4 text-sm text-gray-600" data-id="element-209">
                  <CheckIcon className="w-4 h-4 mr-1 text-green-600" data-id="element-210" />
                  <p data-id="element-211">30-Day Satisfaction Guarantee</p>
                </div>
              </div>
            </div>)}
        </div>
        <div className="max-w-3xl mx-auto mt-12 bg-white text-gray-800 p-6 rounded-lg" data-id="element-212">
          <h3 className="text-xl font-semibold mb-3 text-indigo-800" data-id="element-213">
            Why European Executives Choose NightPhase
          </h3>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-214">
            <li className="flex items-start" data-id="element-215">
              <CheckIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5" data-id="element-216" />
              <span data-id="element-217">No melatonin or habit-forming ingredients</span>
            </li>
            <li className="flex items-start" data-id="element-218">
              <CheckIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5" data-id="element-219" />
              <span data-id="element-220">Clinically tested with high-performance professionals</span>
            </li>
            <li className="flex items-start" data-id="element-221">
              <CheckIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5" data-id="element-222" />
              <span data-id="element-223">Discreet patch application for busy lifestyles</span>
            </li>
            <li className="flex items-start" data-id="element-224">
              <CheckIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5" data-id="element-225" />
              <span data-id="element-226">Wake refreshed with zero morning grogginess</span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
};
export default OfferSection;